Number.isNaN = Number.isNaN || function isNaNPolyfill(value) {
  return value !== value; // eslint-disable-line no-self-compare
};
